webpackJsonp([915738553496],{

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _headerNew = __webpack_require__(26);
	
	var _headerNew2 = _interopRequireDefault(_headerNew);
	
	var _footerNew = __webpack_require__(15);
	
	var _footerNew2 = _interopRequireDefault(_footerNew);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global graphql  */
	var PrivacyPage = function PrivacyPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'wrapper--page' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Privacy Policy - ATTN:' }),
	    _react2.default.createElement(_headerNew2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'cms-page wrapper--max-width' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        data.drupalPage.title
	      ),
	      _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: data.drupalPage.body.value } }),
	      _react2.default.createElement('hr', { className: 'cms-page__spacer' })
	    ),
	    _react2.default.createElement(_footerNew2.default, null)
	  );
	};
	
	exports.default = PrivacyPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-js-ed48c7420cb7446ecbac.js